import { CheckCircle2, XCircle } from 'lucide-react';

interface AssetStatusBadgeProps {
  status?: string | null;
  showIcon?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Badge para exibir o status de um ativo (Ativo/Inativo)
 */
export default function AssetStatusBadge({
  status,
  showIcon = true,
  size = 'sm',
  className = ''
}: AssetStatusBadgeProps) {
  // Normalizar status - se não definido, assume Ativo
  const normalizedStatus = status?.toLowerCase() || 'ativo';
  const isActive = normalizedStatus === 'ativo' || !status;

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm';

  const iconSize = size === 'sm' ? 'h-3 w-3' : 'h-4 w-4';

  if (isActive) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full font-medium
          bg-green-50 text-green-700 ring-1 ring-inset ring-green-200
          ${sizeClasses} ${className}`}
      >
        {showIcon && <CheckCircle2 className={iconSize} />}
        Ativo
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-medium
        bg-red-50 text-red-700 ring-1 ring-inset ring-red-200
        ${sizeClasses} ${className}`}
    >
      {showIcon && <XCircle className={iconSize} />}
      Inativo
    </span>
  );
}
